"use client"

import { useState, useEffect, useRef } from "react"
import { Box, FormControl, InputLabel, Select, MenuItem, TextField, Button, Grid, Typography, CircularProgress } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "@mui/lab/DatePicker";
import frLocale from "date-fns/locale/fr";
import deLocale from "date-fns/locale/de";
import enLocale from "date-fns/locale/en-US";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

//Axios Imports--------
import axios from "axios";
import { variables } from "../../Variables";


//MY IMPORTS-------------------------
import { MyTextField } from "../UI/styledComponents/StyledComponents";
import theme from "../UI/Theme";

// const suppliers = [
//   "ABC Logistics",
//   "Global Supply Co.",
//   "Express Distribution",
//   "Prime Suppliers Ltd.",
//   "Metro Logistics",
// ]

//const projects = ["Project Alpha", "Project Beta", "Project Gamma", "Project Delta", "Project Omega"]

//const distributionStages = ["Planning", "In Transit", "Delivered", "Pending", "Cancelled"]

const localeMap = {
  en: enLocale,
  fr: frLocale,
  de: deLocale,
};

const maskMap = {
  fr: "__/__/____",
  en: "__/__/____",
  de: "__.__.____",
};

export default function DistributionForm({ data, onDataChange, onNext }) {
  //   const AutoCompleteSuppliersList = useRef();
  //   const [suppliersListFiltered, setSuppliersListFiltered] = useState([]);

  const [formData, setFormData] = useState(data);
  const [errors, setErrors] = useState({});
  const [suppliersList, setSuppliersList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [distributionStageList, setDistributionStageList] = useState([])

  const [selectedDistributionDate, setSelectedDistributionDate] =
    useState(null);

  const [loading, setLoading] = useState({ suppliers: false, projects: false });

  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const matches2 = useMediaQuery(theme.breakpoints.down("md"));
  const matches3 = useMediaQuery(theme.breakpoints.down("xl"));

  const [locale, setLocale] = useState("de");

  useEffect(() => {
    setFormData(data);
  }, [data]);

  //for the supplier list----
  //   useEffect(() => {
  //     if (suppliersList?.length > 0) {
  //       const mySuppliersListFiltered = suppliersList.map((option) => {
  //         const firstLetter = option.SUPPLIER_NAME[0].toUpperCase();
  //         return {
  //           firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
  //           ...option,
  //         };
  //       });

  //       setSuppliersListFiltered(mySuppliersListFiltered);
  //     }
  //   }, [suppliersList]);

  //Getting the list of suppliers from D.B------------------------------------------------
  const getSuppliersList = () => {
    axios
      .get(variables.API_URL + "/purchase/supplierslist", {
        withCredentials: true,
      })

      .then((res) => {
        //console.log("fetching suppliers...", res.data.suppliersList);
        setSuppliersList(res.data.suppliersList);
        //dispatch(orderActions.addFullOrdersList(res.data.orderInfo))
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //fetching projects from DB-------------------------------------------
  const getProjectList = () => {
    axios
      .get(
        variables.API_URL + "/projects" + "/0", //zero to get all projects
        { withCredentials: true }
      )

      .then((res) => {
        //console.log("fetching projects...", res.data.projectListInfo);
        setProjectList(res.data.projectListInfo);
        //dispatch(orderActions.addFullOrdersList(res.data.orderInfo))
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //fetching projects from DB-------------------------------------------
  const getDistributionStageList = () => {
    axios
      .get(
        variables.API_URL + "/distribution" + "/", 
        { withCredentials: true }
      )

      .then((res) => {
        console.log("fetching distribution Stage...", res.data.distributionListInfo);
        setDistributionStageList(res.data.distributionListInfo);
        //dispatch(orderActions.addFullOrdersList(res.data.orderInfo))
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getSuppliersList();
    getProjectList();
    getDistributionStageList();
  }, []);

//   const handleChange = (field) => (event) => {
//     const newData = {
//       ...formData,
//       [field]: event.target.value,
//     };
//     setFormData(newData);
//     onDataChange(newData);

//     // Clear error when user starts typing
//     if (errors[field]) {
//       setErrors({
//         ...errors,
//         [field]: "",
//       });
//     }
//   };


  const handleDistributionStage = (event)=>{

    console.log("this is the value passed...",event.target.value)

    const selectedValue = event.target.value
    const selectedStage = distributionStageList.find((stage) => stage.DISTRIBUTIONSTAGE_ID === selectedValue)

    const newData = {
        ...formData,
        distributionStage: selectedValue ? selectedStage.DISTRIBUTIONSTAGE : "",
        distributionStageId: selectedStage ? selectedValue: "",
      };
      setFormData(newData);
      onDataChange(newData);

      if (errors.distributionStage) {
        setErrors({
          ...errors,
          distributionStage: "",
          distributionStageId: "",
        });
      }


  }





  const handleDistributionDate = (date, id) => {
    //console.log("value from the DatePicker", date);

    const dateIsValid = date !== null && date !== "Invalid Date";

    if (id === 0) {
      setSelectedDistributionDate(date);
      if (dateIsValid) {
        const newData = {
          ...formData,
          date: new Date(date.setUTCHours(0, 0, 0, 0)).toISOString(),
        };
        setFormData(newData);
        onDataChange(newData);
      } else {
        // reportVariables = {
        //   ...reportVariables,
        //   selectedDistributionDate: date,
        // };
      }
    } else {
      //console.log("error, date not usable only 2 options available");
      return;
    }
  };

  const validateForm = () => {
    //console.log("here is the formdata...",formData)
    const newErrors = {};

    if (!formData.supplier) newErrors.supplier = "Supplier is required";
    if (!formData.project) newErrors.project = "Project is required";
    if (!formData.date) newErrors.date = "Date is required";
    if (!formData.distributionStage)
      newErrors.distributionStage = "Distribution stage is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      onNext();
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      locale={localeMap[locale]}
    >
      <Box>
        <Typography variant="h6" gutterBottom>
          Enter Distribution Information
        </Typography>

        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.supplier}>
              {/* Suppliers List  */}

              <Autocomplete
                options={suppliersList}
                getOptionLabel={(option) =>
                  `${option.SUPPLIER_NAME}${
                    option.SUPPLIER_ID ? ` (${option.SUPPLIER_ID})` : ""
                  }`
                }
                value={
                  suppliersList.find(
                    (supplier) => supplier.SUPPLIER_ID === formData.supplierId
                  ) || null
                }
                onChange={(event, newValue) => {
                  //console.log("this is new value...", newValue);
                  const newData = {
                    ...formData,
                    supplier: newValue ? newValue.SUPPLIER_NAME : "",
                    supplierId: newValue ? newValue.SUPPLIER_ID : "",
                  };
                  setFormData(newData);
                  onDataChange(newData);

                  // Clear error when user selects
                  if (errors.supplier) {
                    setErrors({
                      ...errors,
                      supplier: "",
                      supplierId: "",
                    });
                  }
                }}
                loading={loading.suppliers}
                disabled={loading.suppliers}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Supplier"
                    error={!!errors.supplier}
                    helperText={errors.supplier}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading.suppliers ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.SUPPLIER_NAME}
                      </Typography>
                      {/* {option.SUPPLIER_ID && (
                    <Typography variant="caption" color="text.secondary">
                      Code: {option.SUPPLIER_ID}
                    </Typography>
                  )} */}
                    </Box>
                  </Box>
                )}
                noOptionsText={
                  loading.suppliers
                    ? "Loading suppliers..."
                    : "No suppliers found"
                }
                filterOptions={(options, { inputValue }) => {
                  return options.filter(
                    (option) =>
                      option.SUPPLIER_NAME.toLowerCase().includes(
                        inputValue.toLowerCase()
                      ) || ""
                    //   (option.SUPPLIER_ID && option.SUPPLIER_ID.toLowerCase().includes(inputValue.toLowerCase())),
                  );
                }}
              />

              {errors.supplier && (
                <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                  {errors.supplier}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.project}>
              {/* Project List --------------------------------------------- */}
              <Autocomplete
                options={projectList}
                getOptionLabel={(option) =>
                  `${option.CLUB_NAME} - ${option.YEAR} ${
                    option.PROJECT_ID ? ` (${option.PROJECT_ID})` : ""
                  }`
                }
                value={
                  projectList.find(
                    (project) => project.PROJECT_ID === formData.projectId
                  ) || null
                }
                onChange={(event, newValue) => {
                  const newData = {
                    ...formData,
                    project: newValue ? newValue.CLUB_NAME : "",
                    projectId: newValue ? newValue.PROJECT_ID : "",
                  };
                  setFormData(newData);
                  onDataChange(newData);

                  // Clear error when user selects
                  if (errors.project) {
                    setErrors({
                      ...errors,
                      project: "",
                      projectId: "",
                    });
                  }
                }}
                loading={loading.projects}
                disabled={loading.projects}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Projects"
                    error={!!errors.projects}
                    helperText={errors.projects}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading.projects ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    <Box>
                      <Typography variant="body1">
                        {option.CLUB_NAME} - {option.YEAR}
                      </Typography>
                      {/* {option.PROJECT_ID && (
                    <Typography variant="caption" color="text.secondary">
                      Code: {option.PROJECT_ID}
                    </Typography>
                  )} */}
                    </Box>
                  </Box>
                )}
                noOptionsText={
                  loading.projects ? "Loading Projects..." : "No Projects found"
                }
                filterOptions={(options, { inputValue }) => {
                  return options.filter(
                    (option) =>
                      (option.CLUB_NAME + option.YEAR)
                        .toLowerCase()
                        .includes(inputValue.toLowerCase()) || ""
                    //   (option.PROJECT_ID && option.PROJECT_ID.toLowerCase().includes(inputValue.toLowerCase())),
                  );
                }}
              />

              {/* <InputLabel>Project</InputLabel>
            <Select
              value={formData.project}
              label="Project"
              onChange={handleChange("project")}
            >
              {projects.map((project) => (
                <MenuItem key={project} value={project}>
                  {project}
                </MenuItem>
              ))}
            </Select> */}
              {errors.project && (
                <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                  {errors.project}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <DatePicker
              mask={maskMap[locale]}
              format="YYY/MM/dd"
              label="Date"
              value={selectedDistributionDate || formData.date}
              //value={formData.date}
              onChange={(date) => handleDistributionDate(date, 0)}
              //onChange={handleChange("date")}
              renderInput={(params) => (
                <MyTextField
                  fullWidth
                  value={formData.date}
                  //onChange={handleChange("date")}
                  error={!!errors.date}
                  helperText={errors.date}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                  //sx={{ margin: matches3 ? "0.2em" : "1em" }}
                />
              )}
            />

            {/* <TextField
            fullWidth
            label="Date"
            type="date"
            value={formData.date}
            onChange={handleChange("date")}
            InputLabelProps={{
              shrink: true,
            }}
            error={!!errors.date}
            helperText={errors.date}
          /> */}
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth error={!!errors.distributionStage}>
              <InputLabel>Distribution Stage</InputLabel>
              <Select
                value={formData.distributionStageId}
                label="Distribution Stage"
                //onChange={handleChange("distributionStage")}
                onChange={handleDistributionStage}
              >
                {/* {distributionStages.map((stage) => ( */}
                {distributionStageList.map((stage) => (
                  <MenuItem key={stage.DISTRIBUTIONSTAGE_ID} value={stage.DISTRIBUTIONSTAGE_ID}>
                    {stage.DISTRIBUTIONSTAGE}
                  </MenuItem>
                ))}
              </Select>
              {errors.distributionStage && (
                <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                  {errors.distributionStage}
                </Typography>
              )}
            </FormControl>
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
          <Button variant="contained" onClick={handleSubmit} size="large">
            Next
          </Button>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
